import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import InputFieldDate from "../../../components/input/input-field-date";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import enUS from "date-fns/locale/en-US";

registerLocale("en-US", enUS);

const DatePickerComponent = () => {
  const [errors, setErrors] = useState({});

  const getLocalDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const today = new Date();
  const todayISOString = today.toISOString().split("T")[0];

  const formatDateMMDDYYYY = (date) => {
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  const getBrowserLocaleFormattedDate = () => {
    return new Intl.DateTimeFormat(navigator.language).format(new Date());
  };

  const todayFormatted = formatDateMMDDYYYY(new Date());

  const validationSchema = () =>
    Yup.object().shape({
      date1: Yup.string()
        .required("Required")
        .test(
          "match-today",
          `Must be today's date: ${todayFormatted}`,
          (value) => formatDateMMDDYYYY(value) === todayFormatted
        ),
      date2: Yup.string()
        .required("Required")
        .test(
          "match-today",
          `Must be today's date: ${todayFormatted}`,
          (value) => formatDateMMDDYYYY(value) === todayFormatted
        ),
      date3: Yup.string()
        .required("Required")
        .test(
          "match-today",
          `Must be today's date: ${todayFormatted}`,
          (value) => formatDateMMDDYYYY(value) === todayFormatted
        ),
      date4: Yup.string()
        .required("Required")
        .test(
          "match-today",
          `Must be today's date: ${todayFormatted}`,
          (value) => formatDateMMDDYYYY(value) === todayFormatted
        ),
      date5: Yup.string()
        .required("Required")
        .test(
          "match-today",
          `Must be today's date: ${todayFormatted}`,
          (value) => formatDateMMDDYYYY(value) === todayFormatted
        ),
      date6: Yup.string()
        .required("Required")
        .test(
          "match-today",
          `Must be today's date: ${todayFormatted}`,
          (value) => formatDateMMDDYYYY(value) === todayFormatted
        ),
      date7: Yup.date()
        .required("Required")
        .test(
          "match-today",
          `Must be today's date: ${todayFormatted}`,
          (value) => formatDateMMDDYYYY(value) === todayFormatted
        ),

              date8: Yup.date()
        .required("Required")
        .test(
          "match-today",
          `Must be today's date: ${todayFormatted}`,
          (value) => formatDateMMDDYYYY(value) === todayFormatted
        ),

            date9: Yup.date()
        .required("Required")
        .test(
          "match-today",
          `Must be today's date: ${todayFormatted}`,
          (value) => formatDateMMDDYYYY(value) === todayFormatted
        ),
    });

  const initialValues = {
    date1: todayISOString,
    date2: getLocalDate(),
    date3: new Date().toLocaleDateString("en-CA"),
    date4:
      new Date().getFullYear() +
      "-" +
      String(new Date().getMonth() + 1).padStart(2, "0") +
      "-" +
      String(new Date().getDate()).padStart(2, "0"),
    date5: new Date().toDateString(), // Example: "Tue Jul 16 2024"
    date6: getBrowserLocaleFormattedDate(), // Based on browser language
    date7: new Date(), // React DatePicker
    date8: new Date(),
    date9: new Date()
  };

  return (
    <div className="container-fluid p-4 bg-light min-vh-100">
      <div className="mb-4">
        <h1 className="display-6 text-primary mb-2">Date</h1>
        <p className="text-muted">Various date input formats with validation</p>
      </div>

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors: formikErrors, touched, handleBlur }) => (
          <div>
            {/* Row 1: Date 1 & Date 2 */}
            <Row className="g-3 ">
              <Col md={6} className="d-flex justify-content-center">
                <div className="card shadow-sm w-50 p-3">
                  <div className="card-header  text-white">
                    <h6 className="card-title mb-0">Date 1</h6>
                  </div>
                  <div className="card-body">
                    <InputFieldDate
                      type="date"
                      name="date1"
                      value={values.date1}
                      min={values.date1}
                      max={values.date1}
                      onBlur={handleBlur}
                      errorMessage={errors.date1}
                    />
                    <div className="bg-light p-2 rounded mt-2">
                      <span className="fw-medium">
                        Value: {formatDateMMDDYYYY(values.date1)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={6} className="d-flex justify-content-center">
                <div className="card shadow-sm w-50 p-3">
                  <div className="card-header  text-white">
                    <h6 className="card-title mb-0">Date 2</h6>
                  </div>
                  <div className="card-body p-3">
                    <InputFieldDate
                      type="date"
                      name="date2"
                      value={values.date2}
                      min={values.date2}
                      max={values.date2}
                      onBlur={handleBlur}
                      errorMessage={errors.date2}
                    />
                    <div className="bg-light p-2 rounded mt-2">
                      <span className="fw-medium">
                        Value: {formatDateMMDDYYYY(values.date2)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Row 2: Date 3 & Date 4 */}
            <Row className="g-3 ">
              <Col md={6} className="d-flex justify-content-center">
                <div className="card shadow-sm w-50 p-3">
                  <div className="card-header  text-white">
                    <h6 className="card-title mb-0">Date 3</h6>
                  </div>
                  <div className="card-body p-3">
                    <InputFieldDate
                      type="date"
                      name="date3"
                      value={values.date3}
                      min={values.date3}
                      max={values.date3}
                      onBlur={handleBlur}
                      errorMessage={errors.date3}
                    />
                    <div className="bg-light p-2 rounded mt-2">
                      <span className="fw-medium">
                        Value: {formatDateMMDDYYYY(values.date3)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={6} className="d-flex justify-content-center">
                <div className="card shadow-sm w-50 p-3">
                  <div className="card-header  text-white">
                    <h6 className="card-title mb-0">Date 4</h6>
                  </div>
                  <div className="card-body p-3">
                    <InputFieldDate
                      type="date"
                      name="date4"
                      value={values.date4}
                      min={values.date4}
                      max={values.date4}
                      onBlur={handleBlur}
                      errorMessage={errors.date4}
                    />
                    <div className="bg-light p-2 rounded mt-2">
                      <span className="fw-medium">
                        Value: {formatDateMMDDYYYY(values.date4)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Row 3: Date 5 & Date 6 */}
            <Row className="g-3">
              <Col md={6} className="d-flex justify-content-center">
                <div className="card shadow-sm w-50 p-3">
                  <div className="card-header  text-white">
                    <h6 className="card-title mb-0">Date 5</h6>
                  </div>
                  <div className="card-body p-3">
                    <InputFieldDate
                      type="date"
                      name="date5"
                      value={todayISOString}
                      min={todayISOString}
                      max={todayISOString}
                      onBlur={handleBlur}
                      errorMessage={errors.date5}
                    />
                    <div className="bg-light p-2 rounded mt-2">
                      <span className="fw-medium">
                        Value: {formatDateMMDDYYYY(new Date())}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={6} className="d-flex justify-content-center">
                <div className="card shadow-sm w-50 p-3">
                  <div className="card-header  text-white">
                    <h6 className="card-title mb-0">Date 6</h6>
                  </div>
                  <div className="card-body p-3">
                    <InputFieldDate
                      type="date"
                      name="date6"
                      value={todayISOString}
                      min={todayISOString}
                      max={todayISOString}
                      onBlur={handleBlur}
                      errorMessage={errors.date6}
                    />
                    <div className="bg-light p-2 rounded mt-2">
                      <small className="text-muted d-block">
                        Browser Locale:
                      </small>
                      <span className="fw-medium text-primary">
                        {new Intl.DateTimeFormat(navigator.language).format(
                          new Date()
                        )}
                      </span>
                      <br />
                      <span className="fw-medium">
                        {" "}
                        Value: {formatDateMMDDYYYY(new Date())}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Row 4: Date 7 (single column, centered) */}
            <Row className="g-3 ">
              <Col md={6} className="d-flex justify-content-center">
                <div className="card shadow-sm w-50 p-3">
                  <div className="card-header text-dark">
                    <h6 className="card-title mb-0">Date 7</h6>
                  </div>
                  <div className="card-body p-3">
                    <div className="mb-3">
                      <DatePicker
                        selected={values.date7}
                        dateFormat="MM/dd/yyyy"
                        className="form-control"
                        min={values.date7}
                        max={values.date7}
                        onBlur={handleBlur}
                      />
                      {formikErrors.date7 && (
                        <div className="text-danger mt-1">
                          {formikErrors.date7}
                        </div>
                      )}
                    </div>
                    <div className="bg-light p-2 rounded">
                      <span className="fw-medium">
                        Value: {formatDateMMDDYYYY(values.date7)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

               <Col md={6} className="d-flex justify-content-center">
                <div className="card shadow-sm w-50 p-3">
                  <div className="card-header text-dark">
                    <h6 className="card-title mb-0">Date 8</h6>
                  </div>
                  <div className="card-body p-3">
                    <div className="mb-3">
                    <DatePicker
  selected={formatDateMMDDYYYY(values.date8)}
  onChange={(date) => setFieldValue("date8", date)}
  onBlur={handleBlur}
  dateFormat="MM/dd/yyyy"
  locale="en-US"
  className="form-control"
  minDate={values.date8}
  maxDate={values.date8}
/>
                      {formikErrors.date8 && (
                        <div className="text-danger mt-1">
                          {formikErrors.date8}
                        </div>
                      )}
                    </div>
                    <div className="bg-light p-2 rounded">
                      <span className="fw-medium">
                        Value: {formatDateMMDDYYYY(values.date8)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

              {/* Row 4: Date 9 (single column, centered) */}
            <Row className="g-3 ">
            

               <Col md={6} className="d-flex justify-content-center">
                <div className="card shadow-sm w-50 p-3">
                  <div className="card-header text-dark">
                    <h6 className="card-title mb-0">Date 9</h6>
                  </div>
                  <div className="card-body p-3">
                    <div className="mb-3">
                    <DatePicker
  selected={(values.date9)}
  onChange={(date) => setFieldValue("date9", date)}
  onBlur={handleBlur}
  dateFormat="MM/dd/yyyy"
  locale="en-US"
  className="form-control"
  minDate={values.date9}
  maxDate={values.date9}
/>
                      {formikErrors.date9 && (
                        <div className="text-danger mt-1">
                          {formikErrors.date9}
                        </div>
                      )}
                    </div>
                    <div className="bg-light p-2 rounded">
                      <span className="fw-medium">
                        Value: {formatDateMMDDYYYY(values.date9)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default DatePickerComponent;
